import Highcharts, { SVGRenderer } from 'highcharts';
import HighchartsAccessibility from 'highcharts/modules/accessibility';

// Add plugins to Highcharts
HighchartsAccessibility(Highcharts);

// We can use this pen to convert SVG icons into things that can be used in
// Highcharts:
// https://codepen.io/taneleero/pen/PoxJYVd

SVGRenderer.prototype.symbols.rect = (
	x: number,
	y: number,
	w: number,
	h: number
) => ['M', x, y + h / 2, 'H', x + w];

Highcharts.SVGRenderer.prototype.symbols.projectStart = (
	x: number,
	y: number,
	_w: number,
	_h: number
) => [
	'M',
	x + 9.1981,
	y + 2.99109,
	'L',
	x + -1.39837,
	y + -3.80755,
	'C',
	x + -2.19816,
	y + -4.32069,
	x + -3.25,
	y + -3.74756,
	x + -3.25,
	y + -2.79863,
	'V',
	y + 10.7986,
	'C',
	x + -3.25,
	y + 11.7476,
	x + -2.19816,
	y + 12.3207,
	x + -1.39837,
	y + 11.8075,
	'L',
	x + 9.1981,
	y + 5.00891,
	'C',
	x + 9.934,
	y + 4.53678,
	x + 9.934,
	y + 3.46322,
	x + 9.1981,
	y + 2.99109,
	'Z',
];

Highcharts.SVGRenderer.prototype.symbols.projectEnd = (
	x: number,
	y: number,
	_w: number,
	_h: number
) => [
	'M',
	x + 3.15178,
	y + -3.64866,
	'C',
	x + 3.62024,
	y + -4.11711,
	x + 4.37976,
	y + -4.11711,
	x + 4.84822,
	y + -3.64866,
	'L',
	x + 11.6487,
	y + 3.15178,
	'C',
	x + 12.1171,
	y + 3.62024,
	x + 12.1171,
	y + 4.37976,
	x + 11.6487,
	y + 4.84822,
	'L',
	x + 4.84822,
	y + 11.6487,
	'C',
	x + 4.37976,
	y + 12.1171,
	x + 3.62024,
	y + 12.1171,
	x + 3.15178,
	y + 11.6487,
	'L',
	x + -3.64866,
	y + 4.84822,
	'C',
	x + -4.11711,
	y + 4.37976,
	x + -4.11711,
	y + 3.62024,
	x + -3.64866,
	y + 3.15178,
	'L',
	x + 3.15178,
	y + -3.64866,
	'Z',
];
